<form name="institutionForm">
  <app-input
    class="tw-w-full"
    [isRequired]="true"
    [label]="'institutionName' | i18n"
    [placeholder]="'enterInstitutionName' | i18n"
    [value]="institutionName"
    (outputValue)="institutionNameChange.emit($event)"
  ></app-input>
  @if (institutionView?.origin === "manual") {
    <span class="tw-text-sm tw-text-dt-text-secondary tw-mt-1 tw-block">
      {{ "institutionMessage" | i18n }}
    </span>
  }

  <app-dropdown-select
    [label]="'country' | i18n"
    [options]="countryOptions"
    [placeholder]="'searchForACountry' | i18n"
    [selectedOption]="institutionCountry"
    (optionSelected)="institutionCountryChange.emit($event)"
    class="tw-m-2"
  ></app-dropdown-select>

  @if (institutionView?.origin === "manual") {
    @if (linkUnavailable) {
      <div class="tw-m-2 tw-flex tw-flex-col tw-items-start tw-gap-1">
        <span class="tw-text-sm tw-text-dt-text-secondary">
          @if (!hasLink && linkRemovalPending) {
            {{ "linkRemovedOnSave" | i18n }}
          } @else if (!hasLink) {
            {{ "sharedInstitutionCantBeLinked" | i18n }}
          } @else if (linkedInstitution) {
            {{ "sharedInstitutionLinkedTo" | i18n: linkedInstitution }}
          } @else {
            {{ "sharedInstitutionLinked" | i18n }}
          }
        </span>
        @if (hasLink) {
          <button
            type="button"
            class="tw-text-sm tw-font-medium tw-text-color-text-action"
            data-testid="remove-institution-link"
            (click)="linkCleared.emit()"
          >
            {{ "removeLink" | i18n }}
          </button>
        } @else if (linkRemovalPending) {
          <button
            type="button"
            class="tw-text-sm tw-font-medium tw-text-color-text-action"
            data-testid="undo-remove-institution-link"
            (click)="linkRestored.emit()"
          >
            {{ "keepLink" | i18n }}
          </button>
        }
      </div>
    } @else {
      <app-dropdown-select
        [label]="'linkAnInstitution' | i18n"
        [options]="institutionOptions"
        [placeholder]="'linkAnInstitution' | i18n"
        [selectedOption]="linkedInstitution"
        (optionSelected)="linkedInstitutionChange.emit($event)"
        [isRequired]="true"
      ></app-dropdown-select>
      <app-dropdown-select
        [label]="'productUnderThisInstitution' | i18n"
        [options]="productOptions"
        [placeholder]="'productUnderThisInstitution' | i18n"
        [selectedOption]="selectedProduct"
        (optionSelected)="linkedProductChange.emit($event)"
        [isRequired]="true"
        class="tw-m-2"
      ></app-dropdown-select>
    }
  }

  <div class="tw-mt-3 tw-w-full tw-flex tw-justify-end">
    <app-gloss-button
      fontClass="tw-font-medium tw-text-sm"
      [options]="saveButtonOptions"
    ></app-gloss-button>
  </div>
</form>
